module.exports = __webpack_public_path__ + "img/photo1.b9d7903c.png";